export function isModuleLoadError(err: unknown): boolean {
  const msg = (err instanceof Error ? err.message : String(err)).toLowerCase()
  return [
    'importing a module script failed',
    'failed to fetch dynamically imported module',
    'error loading dynamically imported module',
    'chunkloaderror',
  ].some(pattern => msg.includes(pattern))
}
